import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";
import FirmList from "../../../firms/FirmList";
import { Link, useNavigate } from "react-router-dom";
import FirmSubUpdate from '../../../firms/FirmSubUpdate';
import FirmSubUserUpdate from '../../../firms/FirmSubUserUpdate';
import ThemeContext from "../../../../context/ThemeContext";
import UserContext from '../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import AgencyCreateSubCoop from "./AgencyCreateSubCoop";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../lang/LangGlb';




const GET_POST = gql`
query MyQuery($firmCode: String!) {
    tbl_firm_main_coop(where: {firm_main_code_n: {_eq: $firmCode}}) {
    own_firm_main_code
    own_firm_sub_code
    own_firm_sub_type
    firm_main_code_n
    firm_main_name_n
    firm_main_type_n
    int_ID
    create_user
    update_user
    created_at
    updated_at
  }
  tbl_firm_sub_coop(where: {firm_main_code_n: {_eq: $firmCode}}) {
    own_firm_main_code
    own_firm_sub_code
    own_firm_sub_type
    firm_main_code_n
    firm_sub_code_n
    firm_sub_name_n
    firm_sub_type_n
    int_ID
    
  }
  tbl_user_detail(where: {firm_main_code: {_eq: $firmCode}}) {
    firm_main_code
    firm_sub_code
    user_name
    name
    last_name
    user_type
    dpr_main_code
    dpr_sub_code
    user_lang
    data_lang
    create_user
    update_user
    created_at
    updated_at
  }
}
`;

const UPDATE_FIRM = gql`
mutation UpdateFirm(
 
  $firmCode: String!
  $firmName: String!
  ) {
  update_tbl_firm_main_coop(
    where: { firm_main_code_n: { _eq: $firmCode } }
    _set: { firm_main_name_n: $firmName }
  ) {
    affected_rows
  }
}
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const INSERT_FIRM = gql`
  mutation InsertFirm(
    $firmCode: String!
    $firmName: String!
    $firmType: String!
    $ownFirmCode: String!
    $ownFirmSubCode: String!
    $ownFirmSubType: String!
    
  ) {
    insert_tbl_firm_main_coop(
      objects: {
        firm_main_code_n: $firmCode,
        firm_main_name_n: $firmName,
        firm_main_type_n: $firmType,
        own_firm_main_code: $ownFirmCode,
        own_firm_sub_code: $ownFirmSubCode,
        own_firm_sub_type: $ownFirmSubType,
        
        
      }
    ) {
      affected_rows
    }
  }
`;

const INSERT_ACC_ACOUNT = gql`
  mutation InsertFirm(
    $firmCode: String!
    $firmName: String!
  
    $ownFirmCode: String!
    $ownFirmSubCode: String!
   
    
  ) {
    insert_tbl_dpr_main(
      objects: {
        dpr_main_code: $firmCode,
        dpr_main_name: $firmName,
        dpr_dpr_type: "AACCC",
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        active: true,
        lang: "en",
        dpr_main_grp_code: "ACARD"
      
        
        
      }
    ) {
      affected_rows
    }
  }
`;





const AgencyCreateCoop = () => {
   
  
  
  
 

  const [updateFirm] = useMutation(UPDATE_FIRM);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertFirm] = useMutation(INSERT_FIRM);
  const [InsertAccCard] = useMutation(INSERT_ACC_ACOUNT);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState("");
  const [firmType, setFirmType] = useState("AGN");
  const [place, setPlace] = useState("");
  const [fmActive, setFmActive] = useState(true);
  const [activeTab, setActiveTab] = useState(1);

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);
  const {varcode, setVarCode} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;

  const lang = users.userLang;
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const new_firm = messages[currentLocale].new_firm;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const placerec = messages[currentLocale].placerec;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const time_zone = messages[currentLocale].time_zone;
  const create_firm = messages[currentLocale].create_firm;
  const create_sub_firm = messages[currentLocale].create_sub_firm;
  const firm_main_code = messages[currentLocale].firm_main_code;
  const firm_sub_code = messages[currentLocale].firm_sub_code;
  const firm_sub_name = messages[currentLocale].firm_sub_name;
  const typerec = messages[currentLocale].typerec;

  const customLocale = {
    emptyMessage: 'Kayıt bulunamadı',
    loading: 'Yükleniyor...',
    currentPageReport: 'Şu anki sayfa {first} ile {last} arası, toplam {totalRecords} kayıt.',
    pagination: {
      first: 'İlk',
      previous: 'Önceki',
      next: 'Sonraki',
      last: 'Son',
      rowsPerPage: 'Sayfa başına satır:'
    },
    // ... diğer çeviriler ...
  };

  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (firmCode !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
    handleinser();  
    
    }
  }, [firmCode, setFirmCode]);


  const handleUpdate = () => {
   
    
    updateFirm({
      variables: {
       
        firmCode: firmCode,
        firmName: firmName,
        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      setFirmCode(updatedIdSeq.toString());  
      setVarCode(updatedIdSeq.toString());  
      console.log(firmCode);
     
       
      
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  };

  const handleinser = () => {
    InsertFirm({
      variables: {
        firmCode: firmCode,
        firmName: firmName,
        firmType: firmType,
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        ownFirmSubType: ownFirmSubType,
    
           
      },
    })
      .then(() => {
        window.alert("Firm insert successfully!");
        handleinser2();
      })
      .catch((error) => {
        console.error("Error insert firm:", error);
      });
  };

  const handleinser2 = () => {
    InsertAccCard({
      variables: {
        firmCode: firmCode,
        firmName: firmName,        
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
       

    
           
      },
    })
      .then(() => {
        window.alert("Account Card insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert firm:", error);
      });
  };

  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmCode: firmCode },
  });

  const firmData = data && data.tbl_firm_sub_coop ? data.tbl_firm_sub_coop[0] : null;    


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    refetch();
  };


  return (

    <div className="container p-2 mx-auto sm:p-4 ">
      <div className="card  ">
    
     <div className=" p-2 ">
          <div className="pt-1 -my-14 -ml-14 -mr-14 font-thin -mb-5"> 
            <Fieldset>
            <p className="my-0 font-thin ">

          <div className="flex gap-4">
          <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_code}</label>
    <InputText className="w-full" 
    id="username" value={firmCode}
    onChange={(e) => setFirmCode(e.target.value)}
    readOnly
    />
  </div>

  <div className="w-2/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{firm_name}</label>
    <InputText className="w-full" 
    id="firmname" value={firmName} 
    onChange={(e) => setFirmName(e.target.value)} autoComplete="off"/>
    
  </div>
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_type}</label>
    <InputText className="w-full" 
    id="firmtype" 
    name="firmtype"
    value={firmType}
    onChange={(e) => setFirmType(e.target.value)}
    readOnly/>
  </div>
  </div>

  
  <div className="flex gap-3 my-5">
    
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_type}</label>
    <InputText className="w-full" 
    id="firmtype" 
    name="firmtype"
    value={firmType}
    onChange={(e) => setFirmType(e.target.value)}
    readOnly/>
  </div>

  

  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="place">{placerec}</label>
    <InputText className="w-full" 
    id="place" 
    name="place"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>

  <div className="w-2/12 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{time_zone}</label>
    <InputText className="w-full" 
    id="timezone" 
    name="timezone"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>

  <div className=" flex-col font-medium  flex justify-content-center">
  
  <label htmlFor="firmtype" 
  className=" flex-col  ml-0 mb-5 align-items-center block font-medium text-gray-950">{statusrec} </label><p></p>
  <div className="flex ml-0 flex-wrap gap-6">
  <div className="flex ml-0 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setFmActive(e.value)} checked={fmActive === true} />
          <label htmlFor="ingredient1" className="ml-2">{activerec}</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setFmActive(e.value)} checked={fmActive === false} />
          <label htmlFor="ingredient2" className="ml-2">{inactiverec}</label>
      </div>
      </div>
      </div>  
      </div>
      <div className="flex  gap-4 ">
      <div className="w-2/4">
     
  </div>
  <div className="w-2/4">
    <Button
      label={create_sub_firm}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={onClick}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={create_firm}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '50vw' }} onHide={onHide}>
  <p>
   <AgencyCreateSubCoop/>
  </p>
</Dialog>
</div>

</p>
    </Fieldset>
        </div>
  
             
        </div>          
       

    
   </div>
  
    <p> <DataTable
         value={data.tbl_firm_sub_coop } responsiveLayout="scroll"
         locale={customLocale}

        >
           <Column field="firm_main_code_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{firm_main_code}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>
          <Column field="firm_sub_code_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{firm_sub_code}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>

          <Column field="firm_sub_name_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{firm_sub_name}</span>}
           style={{ textAlign: 'left', width: '20rem' }}
          >
          </Column>

          <Column field="firm_sub_type_n"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{typerec}</span>}
           style={{ textAlign: 'center', width: '7rem' }}
          >
          </Column>   

         
          <Column field="place"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{placerec}</span>}
           style={{ textAlign: 'right', width: '6rem' }}
          >
          </Column>
    
        </DataTable></p>
        
     
    </div>

    
    
    
 
 
);
};

export default AgencyCreateCoop;
